
const DEFAULT_MAX_STREAM_PLAY_ON_CARD = 2;

/**
 * Parses the maximum number of stream plays allowed on a card.
 * ------------------------------------------------------------
 *
 * @param {unknown} value - Configured limit from an environment variable.
 * @returns {number} A non-negative integer or Infinity.
 */
export const getMaxStreamPlayOnCard = (value) => {
  if (typeof value !== "string" || value.trim() === "") {
    return DEFAULT_MAX_STREAM_PLAY_ON_CARD;
  }

  const configuredLimit = value.trim();

  if (configuredLimit.toLowerCase() === "infinity") {
    return Infinity;
  }

  const parsedLimit = Number(configuredLimit);

  if (!Number.isFinite(parsedLimit) || parsedLimit < 0) {
    return DEFAULT_MAX_STREAM_PLAY_ON_CARD;
  }

  return Math.floor(parsedLimit);
};
